import { apiClient } from "lib/apiClient";

export interface IEditStatus {
  compStatus: string;
}
export const editSaleCompStatus = async (
  compType: string,
  compId: string,
  compStatus: string,
  coins?: number,
  reviewNotes?: string
): Promise<IEditStatus> => {
  const response = await apiClient.post(
    `/reviews/comps/${compType}/${compId}`,
    {
      compStatus,
      coins,
      reviewNotes,
    }
  );

  return response.data;
};
